import { hasS3Object } from "@/lib/aws-amplify/storage";

import { Converter } from "@/components/features/_shared";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type { ProductDummyRoomFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductDummyRoomFormModel["InputModel"] => {
	const { roomDummy } = serverModel;

	const inputModel: ProductDummyRoomFormModel["InputModel"] = {
		capacityAdultMaximum: roomDummy.capacityAdultMaximum,
		capacityKidsMaximum: roomDummy.capacityKidsMaximum,
		capacityPeopleMaximum: roomDummy.capacityPeopleMaximum,
		catchCopy: roomDummy.catchCopy,
		description: roomDummy.description,
		hotelID: roomDummy.hotelID,
		inSale: roomDummy.inSale,
		isKidsUnavailable: roomDummy.isKidsUnavailable,
		keyVisuals: roomDummy.keyVisuals ?? [],
		kidsPolicy: roomDummy.kidsPolicy?.map(Converter.kidsPolicyItemConverter) ?? undefined,
		/**
		 * 旧版で作成される場合、ダミー画像が設定されない
		 */
		mainKeyVisual: hasS3Object(roomDummy.mainKeyVisual) ? roomDummy.mainKeyVisual : DUMMY_IMAGE.s3Object,
		maxRoomNum: roomDummy.maxRoomNum,
		name: roomDummy.name,
		roomID: roomDummy.roomID,
		availablePlanIDs: roomDummy.availablePlanIDs,
	} satisfies ProductDummyRoomFormModel["InputModel"];

	return inputModel;
};
